const TechnicalLV14 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>Riepu kalpošanas laiks</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas ir projektētas un izgatavotas tā, lai ar lielisku veiktspēju nodrošinātu tūkstošiem kilometru. Lai gūtu maksimālo labumu, riepas ir pareizi jāuztur un jāizvairās no riepu bojājumiem un nepareizas izmantošanas, kas var izraisīt riepu kļūmes.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas kalpošanas laiks ir atkarīgs no uzglabāšanas, izmantošanas apstākļiem un ekspluatācijas veida. Visā riepas lietošanas laikā to ietekmē slodze, ātrums, spiediens riepā un ceļa apstākļi. Tā kā izmantošanas apstākļi var būt ļoti atšķirīgi, precīzi prognozēt riepas kalpošanas laiku hronoloģiskā izpratnē nav iespējams.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Patērētāja loma riepu uzturēšanā</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepu izmantošanas pārtraukšanai var būt daudzi iemesli, ieskaitot protektora nodilumu līdz maksimāli pieļaujamajam minimālajam dziļumam, bojājumus vai nepareizu ekspluatāciju, piemēram, dūrienus, griezumus, sitienus, plaisas, izspīlējumus, nepietiekamu spiedienu un pārslodzi. Šo iemeslu dēļ riepas, ieskaitot rezerves riteni, ir jāpārbauda regulāri, t.i., vismaz reizi mēnesī.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Regulāras pārbaudes kļūst īpaši svarīgas, ja riepa tiek ekspluatēta jau ilgāku laiku. Ja ir aizdomas par riepu bojājumu vai tas tiek konstatēts, iesakām to profesionāli pārbaudīt riepu servisā. Patērētājiem vajadzētu izmantot šo konsultāciju, lai noteiktu, vai riepas var droši ekspluatēt arī turpmāk. Ieteicams tajā pašā laikā pārbaudīt arī rezerves riteni.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Šai ikdienas pārbaudei vajadzētu notikt neatkarīgi no tā, vai transportlīdzeklis ir aprīkots ar riepu spiediena kontroles sistēmu (TPMS). Patērētājiem tiek stingri ieteikts pievērst uzmanību savu riepu vizuālajam stāvoklim. Tāpat būtu jāuzmanās no jebkādām dinamiskās veiktspējas izmaiņām, piemēram, pastiprinātas gaisa noplūdes, trokšņa vai vibrācijas.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Šādas izmaiņas var būt rādītājs, ka viena vai vairākas riepas vajadzētu nekavējoties nomontēt un pārbaudīt, lai novērstu to pilnīgu bojāeju. Tāpat patērētājam vajadzētu būt pirmajam, kas pamana izmaiņas riepu ekspluatācijā, un nodrošina to nekavējošu pārbaudi.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepu uzglabāšana un novietošana arī ir svarīga kalpošanas laikam. Vairāk informācijas par pareizu uzglabāšanu, novietošanu un rotāciju var atrast citās publikācijās, kas pieejamas pēc pieprasījuma vai tīmekļa vietnēs.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Ieteikumi riepu kalpošanas ilguma nodrošināšanai</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Mūsu rīcībā nav tehniskās informācijas, kas apstiprinātu noteikta vecuma riepu ekspluatācijas obligātu pārtraukšanu. Tomēr, tāpat kā citi riepu un automobiļu ražotāji, arī <strong>Continental</strong> iesaka visas riepas, ieskaitot rezerves riteni, kas ražotas vairāk nekā pirms 10 gadiem, aizstāt ar jaunām riepām pat tad, ja šķiet, ka tās joprojām ir lietojamas pēc ārējā izskata un protektora dziļums vēl nav sasniedzis minimāli pieļaujamo robežu 1,6 mm.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Automobiļu ražotāji var ieteikt citu riepu vecumu, pēc kura riepas vajadzētu nomainīt, pamatojoties uz konkrētā transportlīdzekļa ekspluatācijas nosacījumiem. Ieteicams ievērot jebkādu šādu ražotāja norādījumu.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Patērētājiem vajadzētu atcerēties, ka lielākā daļa riepu tiek nomainītas protektora nodiluma vai citu iemeslu dēļ vēl pirms šī noteiktā laika. Noteiktais periods nekādā veidā nesamazina patērētāja atbildību nomainīt riepas, kad tas ir nepieciešams.</p>

            <p>&nbsp;</p>
        </div>
    );
};

export default TechnicalLV14;


